import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

/**
 * Exports data to an Excel file.
 * @param {Array} columns - Array of column definitions (with field and headerName).
 * @param {Array} rows - Array of row objects.
 * @param {string} fileName - Name of the Excel file to download.
 */
export function exportToExcel(columns, rows, fileName = 'data') {
  // Always append today's date to the file name
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  // Remove .xlsx if user passed it
  fileName = `${fileName}_${yyyy}-${mm}-${dd}.xlsx`;

  // Prepare header and data
  const headers = columns.map(col => col.headerName || col.field);
  const fields = columns.map(col => col.field);
  const data = rows.map(row => fields.map(field => row[field]));
  const worksheetData = [headers, ...data];

  // Create worksheet and workbook
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  // Write and trigger download
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, fileName);
}
